import { createContext } from "react";
import { settings } from "../config";

const AppContext = createContext(settings);

export const EmailContext = createContext({ emails: [] });

export const ProductContext = createContext({ products: [] });

export const FeedContext = createContext({ feeds: [] });

export const AuthWizardContext = createContext({ user: {} });

// export const UserContext = createContext({ user: {"Name":"Renish"} });

export const ChatContext = createContext();

export const KanbanContext = createContext({
  KanbanColumns: [],
  kanbanTasks: [],
});

export const APITestingContext = createContext({});

export const WebhookContext = createContext({});

export const BillingContext = createContext({});

export const PublishAppContext = createContext({});

export default AppContext;
